<div class="brook-feature-area pb--150 pb_md--80 pb_sm--60 bg_color--1">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="brook-section-title mb--10">
                    <h3 class="heading heading-h3">Disfruta de nuestros beneficios</h3>
                </div>
                <div class="row">

                    <!-- Start Single Feature -->
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="bk-feature d-flex mt--70">
                            <div class="icon">
                                <i class="ion-ios-infinite theme-color"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Contenido Original</h5>
                                <div class="bkseparator--20"></div>
                                <p class="bk_pra">Disfruta de contenido original disponible en español e inglés.</p>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Feature -->

                    <!-- Start Single Feature -->
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="bk-feature d-flex mt--70">
                            <div class="icon">
                                <i class="ion-monitor theme-color"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Plataforma E-Learning</h5>
                                <div class="bkseparator--20"></div>
                                <p class="bk_pra">Disponemos de material exclusivo y único para nuestros estudiantes.</p>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Feature -->

                    <!-- Start Single Feature -->
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="bk-feature d-flex mt--70">
                            <div class="icon">
                                <i class="ion-ios-baseball-outline theme-color"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Streaming en Vivo</h5>
                                <div class="bkseparator--20"></div>
                                <p class="bk_pra">Disfruta de clases en vivo desde la comodidad de tu casa.</p>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Feature -->

                    <!-- Start Single Feature -->
                    <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="bk-feature d-flex mt--70">
                            <div class="icon">
                                <i class="ion-pinpoint theme-color"></i>
                            </div>
                            <div class="content">
                                <h5 class="heading heading-h5">Comunidad Espiritual </h5>
                                <div class="bkseparator--20"></div>
                                <p class="bk_pra">Despierta tu consciencia junto a miles de miembros al rededor del mundo.</p>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Feature -->
                    
                    </div>
            </div>
            
            <div class="col-lg-4 mt_md--50 mt_sm--50">
                <div class="thumb text-center">
                    <img src="assets/img/about/iphone-01.png" alt="about images">
                </div>
            </div>
        </div>
        
    </div>
</div>
